export default "__VITE_ASSET__C3wngruP__"